<template>
  <base-modal
    :closeable-from-outside="true"
    hideFooter
    :size="'xl'"
    @hidden="$emit('onCloseModal')"
    :modalId="'export-code-info-modal'"
  >
    <!-- <template #modal-header>
      <b-row>
        <b-col cols="12" class="px-2 mb-1">
          <div class="head-label"><b>Export CodeTemplate</b></div>
        </b-col>
      </b-row>
    </template> -->
      <b-row>
        <b-col cols="12" class="px-2 mb-2">
          <div class="content-brand-detail container-card">
            <b-tabs 
              v-model="tabIndex"
              class="custom-tabs"
            >
              <b-tab lazy :active="formData.tab == 'export'" @click="checkInitTab('export')">
                <template #title>
                  <feather-icon icon="DownloadIcon" size="16" class="mr-0 mr-sm-50" />
                  <span class="d-none d-sm-inline">Export</span>
                </template>
                <export-code
                  :templateId="templateId"
                  :templateData="templateData"
                  @onNext="onNextStep"
                />
              </b-tab>
              <b-tab lazy :active="formData.tab == 'history'" @click="checkInitTab('history')">
                <template #title>
                  <feather-icon icon="FileIcon" size="16" class="mr-0 mr-sm-50" />
                  <span class="d-none d-sm-inline">History</span>
                </template>
                <export-code-history
                  :templateId="templateId"
                  :templateData="templateData"
                />
              </b-tab>
              <b-tab lazy :active="formData.tab == 'import'" @click="checkInitTab('import')">
                <template #title>
                  <feather-icon icon="FileIcon" size="16" class="mr-0 mr-sm-50" />
                  <span class="d-none d-sm-inline">Update Customer Issue</span>
                </template>
                <import-update-cus
                  :templateId="templateId"
                  :templateData="templateData"
                />
              </b-tab>
            </b-tabs>
          </div>
          <!-- <div class="mt-2 mb-2">
            <div class="d-flex justify-content-center">
              <cancel-button class="mr-1" @click.native="onCloseModal" />
            </div>
          </div> -->
        </b-col>
      </b-row>
  </base-modal>
</template>

<script>
import {ref,reactive,getCurrentInstance } from "@vue/composition-api";
import router from "@/router";
import vSelect from "vue-select";
import ExportCode from './modal/ExportCode.vue';
import ExportCodeHistory from './modal/ExportCodeHistory.vue'
import ImportUpdateCus from './modal/ImportUpdateCus.vue'
export default {
  components: {
    vSelect,
    ExportCode,
    ExportCodeHistory,
    ImportUpdateCus,
  },
  props: {
    templateId: { type: [Number, String], default: 1 },
    templateData: { type: [Object, Array], default: null },
  },
  setup(){
    const vm = getCurrentInstance().proxy;
    //Data
    const formData = reactive({
      tab: "export",
    });

    const tabIndex = ref(0);

    const onNextStep = () => {
      tabIndex.value++
    }
    //Method
    const checkInitTab = (tabId) => {
      switch (tabId) {
        case "export":
          formData.tab = "export";
          break;
        case "history":
          formData.tab = "history";
          break;
        case "import":
          formData.tab = "import";
          break;
      }
    };

    const onCloseModal = () => {
      vm.$emit('onCloseModal');
    };

    const changeTab = (tab) => {
      let routeReplace = router.currentRoute.fullPath.split("&tab")[0];
      router.replace(routeReplace + "&tab=" + tab);
    };

    return {
      formData,
      tabIndex,
      onNextStep,
      checkInitTab,
      changeTab,
      onCloseModal,
    };
  } 
}
</script>

<style scoped>
@import '~@/assets/css/override-styles/progress-nav.css';
@import '~@/assets/css/pages/privilege/privilege-code-template/code-template-exportcode.css';
</style>